import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicBoxDataSourceService } from '../../services/public-box-data-source.service';
import { Observable, switchMap } from 'rxjs';
import { PublicBoxDetails } from '../../models/public-box-details';
import { toObservable } from '@angular/core/rxjs-interop';
import { SpinnerFilledComponent } from '@web/shared/ui';
import { Carousel } from 'primeng/carousel';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicBoxCarouselItemComponent } from '../../components/public-box-gallery-carousel-item/public-box-carousel-item.component';
import { isNotEmptyArray } from '@web/utils';

@Component({
  selector: 'app-public-box-gallery-carousel',
  imports: [
    CommonModule,
    SpinnerFilledComponent,
    Carousel,
    PublicBoxCarouselItemComponent,
  ],
  templateUrl: './public-box-gallery-carousel.component.html',
  styleUrl: './public-box-gallery-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBoxGalleryCarouselComponent {
  private readonly publicBoxDataSource = inject(PublicBoxDataSourceService);

  public readonly styleClass = input<string>();
  public readonly slug = input.required<string>();

  protected readonly slug$ = toObservable(this.slug);
  protected readonly box$ = this.boxSource();

  protected isMoreThanOne(banners: Multimedia[]): boolean {
    return banners.length > 1;
  }

  private boxSource(): Observable<PublicBoxDetails> {
    return this.slug$.pipe(
      switchMap((slug) => this.publicBoxDataSource.fetchDetailsBySlug(slug)),
    );
  }

  protected readonly isNotEmptyArray = isNotEmptyArray;
}
